import { Component, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { UtilService } from 'src/app/services/utilService/util.service';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css']
})
export class ModalComponent implements OnInit, OnDestroy {
  private destroyListener?: () => void;
  @Input() modalId: string = '';
  @Input() modalTitle: string = '';
  @Input() modalSize: string = '';
  
  constructor(private utilService: UtilService, private renderer: Renderer2) { }

  closeModal(){
    if(this.modalId && this.modalTitle){
      this.utilService.closeModal(this.modalId);
    }
  }
  ngOnInit(): void {
    this.destroyListener = this.renderer.listen('document', 'keydown', (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        this.closeModal();
      }
    });
  }

  ngOnDestroy(): void {
    if(this.destroyListener){
      this.destroyListener();
    }
  }
}
